import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { downtimeGuard } from './common/guards/downtime.guard';
import { groupPermissionGuard } from './common/guards/group-permission.guard';
import { RedirectComponent } from './redirect/redirect.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/order-management/tracker'
  },
  {
    path: "redirect",
    component: RedirectComponent
  },
  {
    path: 'order-management/tracker',
    loadComponent: () => import('./order-management/tracker/orders-tracker.component').then(c => c.OrdersTrackerComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'scheduling/tracker',
    loadComponent: () => import('./scheduling/tracker/scheduling-tracker.component').then(c => c.SchedulingTrackerComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./reports/reports.component').then(c => c.ReportsComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/facilities',
    loadComponent: () => import('./facilities/facilities.component').then(c => c.FacilitiesComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/statuses',
    loadComponent: () => import('./statuses/statuses.component').then(c => c.StatusesComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/priorities',
    loadComponent: () => import('./priorities/priorities.component').then(c => c.PrioritiesComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/cpt-codes',
    loadComponent: () => import('./cpt-codes/cpt-codes.component').then(c => c.CptCodesComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/diagnosis',
    loadComponent: () => import('./diagnosis/diagnosis.component').then(c => c.DiagnosisComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/users',
    loadComponent: () => import('./users/users.component').then(c => c.UsersComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/online-help',
    loadComponent: () => import('./online-help/online-help.component').then(c => c.OnlineHelpComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/downtime',
    loadComponent: () => import('./downtime/downtime.component').then(c => c.DowntimeComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'unavailable',
    loadComponent: () => import('./unavailable/unavailable.component').then(c => c.UnavailableComponent),
    canActivate: [MsalGuard, downtimeGuard]
  },
  {
    path: 'not-authorized',
    loadComponent: () => import('./403/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
  },
  {
    path: 'not-authenticated',
    loadComponent: () => import('./401/unauthenticated/unauthenticated.component').then(c => c.UnauthenticatedComponent)
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./404/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  }
];
